<template>
  <div id="ticket">
    <div class="ticket-scroller">
      <div class="first-step step">

        <div class="header--ticket">
          <img src="../assets/header-ticket.png" />
          <p>
            <span v-html="
              $i18n.locale == 'it' ?
              `Offriamo menu senza CO<sub>2</sub> da sempre`
              :
              `Proudly lowering the impact of food on the environment`
            "></span>
          </p>
        </div>
        <div class="inner-block">
          <p>
            {{
              $i18n.locale == 'it' ?
              "Nome cameriere: Pianeta Terra"
              :
              "Server name: Planet Earth"
            }}
          </p>
          <div class="inner-row">
            <div class="balloon-ticket">
              {{
                $i18n.locale == 'it' ? 
                "Grazie per aver scelto di mangiare con noi! Ecco quanto è costato il tuo pasto oggi:"
                :
                "We thank you for choosing to dine with us! Here’s a breakdown of how much your meal costs today:"
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="second-step step">
        <div class="inner-block">
          <div class="inner-row">
            <div class="price-ticket" 
            v-html="
                $i18n.locale == 'it' ? 
                `Il “prezzo” dei tuoi piatti in termini di CO<sub>2</sub> prodotta:`
                :
                `The “price” of your dishes in terms of CO<sub>2</sub> eq. produced:`
            ">
            </div>
          </div>
          <div class="plates-cf-wrap">
            <div class="row-cf" v-for="(plate, index) in arrayTicket" :key="index">
              <div class="col-cf">
                <img :src="plate.thumbImage" />
                <p class="row-cf-name">{{plate.name}}</p>
              </div>
              <p>{{valoriArray[plate.index].co2.replace(',', '.')}}<span> kg </span></p>
            </div>
            <div class="row-cf last-row">
              <p>
                {{
                  $i18n.locale == 'it' ? 
                  "Totale "
                  :
                  "Total "
                }} 
                <span class="small-text" 
                  v-html="
                    $i18n.locale == 'it' ? 
                    `(valore max sostenibile: <b>1kg</b>)`
                    :
                    `(max sustainable value: <b>1kg</b>)`
                  ">
                </span>
              </p>
              <p><b :style="{ color: totalCo2 > 1 ? '#E5342C' : '#289948'}">{{totalCo2}} kg</b> </p>
            </div>
          </div>
          <div class="car--wrap">
            <p> 
              <span v-html="
                $i18n.locale == 'it' ? 
                `Equivale alla CO<sub>2</sub> generata da un viaggio di `
                :
                `That's equal to the CO<sub>2</sub> produced with a ` 
              "
            ></span>
            <b :style="{ color: totalCo2 > 1 ? '#E5342C' : '#289948'}">{{totalKms}} km</b>
            {{
              $i18n.locale == 'it' ? 
              `!`
              :
              `road trip!`
            }}
            </p>
            <div class="road-wrap">
              <img id="road-car" src="../assets/car.svg" />
              <div class="line--dotted"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="third-step step">
        <div class="inner-block">
          <div class="inner-row">
            {{
              $i18n.locale == 'it' ? 
              "Il pasto che hai composto ha totalizzato:"
              :
              "The meal you composed has totaled:"
            }}
          </div>
          <div class="nutrition-table--wrap">
            <div class="nutrition-table">
              <div class="nutrition-row">
                <p>
                  {{
                    $i18n.locale == 'it' ? 
                    "Calorie"
                    :
                    "Calories"
                  }}
                </p>
                <p>{{totalKcal}}kcal</p>
              </div>
              <div class="nutrition-row">
                <p>
                  {{
                    $i18n.locale == 'it' ?
                    "Grassi totali" 
                    :
                    "Total Fat"
                  }}
                </p>
                <p>{{totalFat}}g</p>
              </div>
              <div class="nutrition-row">
                <p>
                  {{
                    $i18n.locale == 'it' ? 
                    "Grassi saturi"
                    :
                    "Saturated Fat"
                  }}
                </p>
                <p>{{totalSaturated}}g</p>
              </div>
              <div class="nutrition-row">
                <p>
                  {{
                    $i18n.locale == 'it' ? 
                    "Carboidrati"
                    :
                    "Carbohydrate"
                  }}
                </p>
                <p>{{totalCarbs}}g</p>
              </div>
              <div class="nutrition-row">
                <p>
                  {{
                    $i18n.locale == 'it' ? 
                    "Proteine"
                    :
                    "Protein"
                  }}
                </p>
                <p>{{totalProtein}}g</p>
              </div>
              <div class="nutrition-row">
                <p>
                  {{
                    $i18n.locale == 'it' ? 
                    "Fibre"
                    :
                    "Fibers"
                  }}
                </p>
                <p>{{totalFiber}}g</p>
              </div>
            </div>
          </div>
          <div class="daily-compo">
            <p class="small-type"
              v-html="
              $i18n.locale == 'it' ?
              `I grassi saturi non dovrebbero superare i 25 g al giorno. Ne sono ricchi i formaggi, il burro, l’olio di palma e di cocco, i latticini, gli insaccati e i salumi. Per ridurre i grassi saturi, quando condisci e cucini prediligi gli oli vegetali non tropicali come l’olio extravergine di oliva e scegli più spesso legumi, pesce e carne bianca.
              <br><br>
              Le fibre sono molto importanti per la salute. Cerca di assumerne 15 g ogni 1.000 Kcal. Per arricchire di fibre la tua dieta, scegli cereali integrali, legumi, frutta, verdura e frutta secca.
              `
              :
             ` Saturated fat should not exceed 25 g a day. These are found in cheeses, butter, palm and coconut oil, dairy products, cured meats, sausages. To reduce saturated fats, prefer non-tropical vegetable oils like extra virgin olive oil when seasoning and cooking, and choose legumes, white meat and fish more often. 
              <br><br>
              Fiber is very important for health. Aim for 15 g of it for every 1000 Kcal. To increase the fiber in your diet, choose whole grains, legumes, fruits vegetables and nuts.`
            "></p>
          </div>
        </div>
        <div class="bg-last">
          <img src="../assets/ticket-footer.png" />
        </div>
      </div>
      <div class="fourth-step step">
        <div class="inner-block">
          <h3 v-html="
              $i18n.locale == 'it' ?
              `GRAZIE per aver scelto un menu senza CO<sub>2</sub>!`
              :
              `Thank YOU for limiting CO<sub>2</sub> on the menu!`
            ">
          </h3>
          <h3>
            {{
              $i18n.locale == 'it' ?
              "Torna presto a trovarci!"
              :
              "Come back soon!"
            }}
          </h3>
        </div>
      </div>
      <div class="fifth-step step">
        <div class="inner-block">
          <div class="balloon stagger-fifth">
            <p class="stagger-fifth" v-html="
              $i18n.locale == 'it' ?
              `Penso che abbiamo fatto un buon lavoro analizzando il modo in cui bisogna pensare al cibo.<br/>
                Pensi di essere pronto/a per impegnarti ogni giorno a mangiare sempre più alimenti sani`
              :
              `I think we’ve done a good job exploring how food needs to be thought about.<br/>
              Do you think you’re ready to make the daily commitment to eat more and more healthy and sustainable foods?` 
            ">
            </p>
            <div class="avatar--res stagger-fifth">
              <img :src="require(`../assets/pdcm.png`)"/>
            </div>
          </div>
          
          <div class="cta-badge-dishes stagger-fifth" @click="openBadgeOverlay">
            {{
              $i18n.locale == 'it' ?
              "🙌 Senz'altro!"
              : 
              "🙌 Definitely!" 
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="scroll-ticket-wrap">
      <img src="../assets/arrow-ticket-next.svg" @click="nextStep"/>
    </div>
  </div>
</template>

<script>
import {gsap} from 'gsap';
import {valori} from '@/valori.js'

export default {
  name: 'Ticket',
  props: ['arrayTicket', 'firstTrigger'],
  data(){
    return {
      step: 0,
      valoriArray: valori,
      totalCo2: 0,
      totalKcal: 0,
      totalFat: 0,
      totalSaturated: 0,
      totalCarbs: 0,
      totalProtein: 0,
      totalFiber: 0,
      canClick: true,
      totalKms:0
    }
  },
  methods:{
    transitionStep(val){

      if(val === 1){
        this.countTotal()
        var TL = gsap.timeline()
        TL
        .to('#ticket', {top: 0, duration: .75, ease: "Power2.easeInOut"})
        .to('.first-step .inner-block', {opacity: 1, duration: .5, ease: "Power2.easeInOut", onComplete:() =>{
          this.canClick = true
        }})
      }else if(val === 2){
        var TL2 = gsap.timeline()
        var rows = document.querySelectorAll('.second-step .inner-block .row-cf')
        var arrayRows = Array.prototype.slice.call(rows);
        document.getElementById('road-car').classList.add('start-animation')
        TL2
        .to('.ticket-scroller', {top: '-100vh', duration: .75, ease: "Power2.easeInOut"})
        .to('.second-step .inner-block', {opacity: 1, duration: .5, ease: "Power2.easeInOut"})
        .to(arrayRows, {opacity: 1, duration: .5, ease: "Power2.easeInOut", stagger: .05, onComplete:() =>{
          this.canClick = true
          
        }})
        

      }else if(val === 3){
        var TL3 = gsap.timeline()
        var nutritionRows = document.querySelectorAll('.third-step .inner-block .nutrition-row')
        var arrayNutrition = Array.prototype.slice.call(nutritionRows);
        TL3
        .to('.ticket-scroller', {top: '-200vh', duration: .75, ease: "Power2.easeInOut"})
        .to('.third-step .inner-block', {opacity: 1, duration: .5, ease: "Power2.easeInOut"})
        .to(arrayNutrition, {opacity: 1, duration: .5, ease: "Power2.easeInOut", stagger: .05, onComplete:() =>{
          this.canClick = true
        }})
        
      } else if(val === 4){
        var TL4 = gsap.timeline()
        var heightScroll = document.querySelector('.ticket-scroller').clientHeight - document.querySelector('.fourth-step').clientHeight - document.querySelector('.fifth-step').clientHeight;

        TL4
        .to('.ticket-scroller', {top: -heightScroll, duration: .75, ease: "Power2.easeInOut"})
        .to('.scroll-ticket-wrap', {autoAlpha: 0, duration: .5, ease: "Power2.easeInOut"}, '-=.5')
        .to('.fourth-step .inner-block', {opacity: 1, duration: .5, ease: "Power2.easeInOut", onComplete: () => {
          var TL5 = gsap.timeline();
          var heightScroll = document.querySelector('.ticket-scroller').clientHeight - (document.querySelector('.fifth-step').clientHeight /2) - document.querySelector('.fourth-step').clientHeight;

          TL5
          .to('.ticket-scroller', {top: -heightScroll, duration: .75, delay: 2, ease: "Power2.easeInOut"})
          .to('.fifth-step .inner-block', {opacity: 1, duration: .5,  ease: "Power2.easeInOut", 
            onStart: () => {
              gsap.to('.stagger-fifth', {opacity: 1, stagger: 0.1, duration: .5, ease: "Power2.easeInOut"})
            }
        })
        }})
      } 
    },
    countTotal(){

      for(var i = 0; i < this.arrayTicket.length; i++){
        let co2 = this.valoriArray[this.arrayTicket[i].index].co2
        co2 = co2.replace(",", ".")

        let kcal = this.valoriArray[this.arrayTicket[i].index].kcal
        kcal = kcal.replace(",", ".")

        let fat = this.valoriArray[this.arrayTicket[i].index].grassi
        fat = fat.replace(",", ".")
        fat = Math.floor(fat)

        let saturated = this.valoriArray[this.arrayTicket[i].index].saturi
        saturated = saturated.replace(",", ".")
        saturated = Math.floor(saturated)

        let carbs = this.valoriArray[this.arrayTicket[i].index].carboidrati
        carbs = carbs.replace(",", ".")
        carbs = Math.floor(carbs)

        let proteins = this.valoriArray[this.arrayTicket[i].index].proteine
        proteins = proteins.replace(",", ".")
        proteins = Math.floor(proteins)

        let fiber = this.valoriArray[this.arrayTicket[i].index].fibra
        fiber = fiber.replace(",", ".")
        fiber = Math.floor(fiber)

        let kmsDone = this.valoriArray[this.arrayTicket[i].index].km
        kmsDone = kmsDone.replace(",", ".")
        
        this.totalCo2 = (parseFloat(this.totalCo2) + parseFloat(Number(co2))).toFixed(2)
        this.totalKcal = (parseFloat(this.totalKcal) + parseFloat(Number(kcal)))
        this.totalFat = (parseFloat(this.totalFat) + parseFloat(Number(fat)))
        this.totalSaturated = (parseFloat(this.totalSaturated) + parseFloat(Number(saturated)))
        this.totalCarbs = (parseFloat(this.totalCarbs) + parseFloat(Number(carbs)))
        this.totalProtein = (parseFloat(this.totalProtein) + parseFloat(Number(proteins)))
        this.totalFiber = (parseFloat(this.totalFiber) + parseFloat(Number(fiber)))
        this.totalKms = (parseFloat(this.totalKms) + parseFloat(Number(kmsDone))).toFixed(2)

      }

      
    },
    nextStep(){

      if(!this.canClick) return false;
      this.step++;
      this.canClick = false
    },

    openBadgeOverlay(){
      this.$store.dispatch('openBadge', 'dishes')
    }
  },
  mounted(){
  },
  watch: {
    step(newVal){
      this.transitionStep(newVal)
    },
    firstTrigger(){
      this.step = 1
    }
  }
}
</script>

<style lang="scss">
  #ticket{
    position: absolute;
    top: 100vh;
    width: 70%;
    max-width: 800px;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    height: 100vh;
    @media screen and(max-width: 860px){
      width: 80%;
    }
    @media screen and(max-width: 767px){
      width: 90%;
    }
  
    .ticket-scroller{
      position: absolute;
      width: 100%;
      z-index: 4;
    }
    .header--ticket{
      position: relative;
      width: 100%;
      text-align: center;
      img{
        display: block;
        width: 100%;
        margin: 0 auto 20px;
      }
      p{
        font-size: 18px;
        line-height: 24px;
        margin: 0 auto 50px;
        @media screen and(max-width: 767px){
          font-size: 14px;
          margin: 0 auto 30px;
        }
      }
    }
    .step{
      position: relative;
      height: 100vh;
      background-color: #fff;
      &.second-step, &.third-step{
        .inner-block{
          padding-top: 60px;
        }
      }
      &.third-step{
        .inner-block{
          z-index: 2;
          .inner-row{
            text-align: center;
            margin: 0 auto;
            justify-content: center;
          }
        }
      }
      &.fourth-step{
        background-color: #F9DC5F;
        height: auto;
        padding-top: 40%;
        padding-bottom: 50px;
        text-align: center;
        h3{
          font-size: 48px;
          line-height: 56px;
          text-align: center;
          margin: 0 auto 30px;
          @media screen and(max-width: 767px){
            font-size: 30px;
            line-height: 48px;
          }
        }
      }
      &.fifth-step{
        position: relative;
        margin-top: 68px;
        background-color: transparent;
        .inner-block{
          width: 100%;
          position: absolute;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          z-index: 3;
        }
        .balloon{
          width: 100%;
          background-color: #fff;
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
          border-bottom-right-radius: 5px;
          text-align: center;
          margin-bottom: 20px;
          p{
            padding: 50px 20px;
            opacity: 0;
          }
        }
        .avatar--res{
          position: absolute;
          bottom: 0;
          left: 0;
          transform: translate(0%, 50%);
          opacity: 0;
          margin: 0;
          width: 150px;
          img{
            display: block;
            width: 100%;
          }
        }
        .cta-badge-dishes{
          right: 0;
          text-align: right;
          margin: 20px 0 0 auto;
          border: 1px solid #2E70E2;
          background-color: #2E70E2;
          color: #fff;
          padding: 16px 20px;
          font-size: 18px;
          border-radius: 5px;
          opacity: 0;
          cursor: pointer;
        }
      }
    }
    .inner-block{
      position: relative;
      font-size: 24px;
      line-height: 32px;
      text-align: left;
      opacity: 0;
      width: 80%;
      margin: 0 auto;
      @media screen and(max-width: 767px){
        width: 90%;
        font-size: 18px;
        line-height: 24px;
      }
      .inner-row{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 30px 0;
        margin: 0 auto;
        @media screen and(max-width: 767px){
          padding: 15px 0;
          flex-direction: column-reverse;
          align-items:flex-start;
        }
      }
      p{
        margin: 0 auto ;
        text-align: center;
      }
      .balloon-ticket{
        align-self: flex-start;
        padding: 30px 20px;
        background-color: #fff;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border: 1px solid #000;
        text-align: center;
        margin-left: 20px;
        @media screen and(max-width: 767px){
          margin-left: 0;
          padding: 20px 10px;
        }
      }
      .price-ticket{
        align-self: flex-start;
        padding: 0 0 16px;
        border-bottom: 3px solid #000;
        font-weight: bold;
        width: 100%;
      }
      .earth{
        text-align: left;
        display: inline-block;
        margin: 0;
        flex: 1 0 80px;
        width: 65px;
        opacity: 0;
        transform: translateX(-20px);
        img{
          display: block;
          width: 100%;
        }
        @media screen and(max-width: 767px){
          margin-top: 15px;
        }
      }
    }
    .plates-cf-wrap{
      position: relative;
      width: 100%;
      .small-text{
        font-size: 14px;
      } 
      .row-cf{
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 10px;
        opacity: 0;
        img{
          display: block;
          width: 65px;
          @media screen and(max-width: 767px){
            width: 30px;
          }
        }
        p{
          margin: 0;
          text-align: left;
        }
        
        .col-cf{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex: 1 0 70%;
          p{
            margin-left: 20px;
          }
        }
        &.last-row{
          border-top: 1px solid #000;
          padding-top: 20px;
          margin-top: 20px;
        }
        @media screen and(max-width: 767px){
          font-size: 16px;
          line-height: 20px;
          .col-cf{
            p{
              margin-left: 15px;
            }
          }
          p{
            span{
              font-size: 12px;
            }
          }
          &.last-row{
            padding-top: 20px;
            margin-top: 20px;
          }
        }
      }
    }
    .car--wrap{
      position: relative;
      width: 100%;
      padding-top: 30px;
      overflow-x: hidden;
      p{
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        padding-bottom: 30px;
      }
      .road-wrap{
        position: relative;
        width: 100%;
        height: 110px;
        background-color: #E2E7EC;
        .line--dotted{
          position: absolute;
          width: 100%;
          top: 14px;
          left: 0;
          height: 3px;
          background-image: linear-gradient(to right, #000 50%, rgba(255, 255, 255, 0) 0%);
          background-position: top;
          background-size: 10px 10px;
          background-repeat: repeat-x;
        }
        img {
          position: absolute;
          left: 0;
          top: -14px;
          z-index: 2;
          &.start-animation{
            animation: drive 3s ease-out infinite;
          }
        }
      }
    }
    .nutrition-table--wrap{
      position: relative;
      background-color: #E2E7EC;
      width: 100%;
      z-index: 2;
      @media screen and(max-width: 767px){
        margin-top: 10px;
        width: auto;
      }
      .nutrition-table{
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 20px;
        .nutrition-row{
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #000;
          font-size: 18px;
          line-height: 36px;
          opacity: 0;
          p{
            margin: 0;
          }
          &:nth-child(1){
            font-weight: 700;
            border-bottom: 3px solid #000;
          }
          @media screen and(max-width: 767px){
            font-size: 16px;
            line-height: 24px;
          }
        }
      }
    }
    .bg-last{
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      img{
        display: block;
        width: 100%;
      }
    }
    .scroll-ticket-wrap{
      position: fixed;
      bottom: 0;
      width: 100%;
      height: 120px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: flex-start;
      text-align: center;
      z-index: 4;
      img{
        margin: 0 auto;
        cursor: pointer;
      }
    }
    .daily-compo{
      margin-top: 20px;
      .small-type{
        font-size: 12px;
        line-height: 18px;
        text-align: left;
      }
    }
  }
  
  @keyframes drive {
    0%{
      left: -10%;
    }
    100%{
      left: 110%;
    }
  }
</style>